import ListPageWrapper from "../../ListPageWrapper";
import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {ContentDetailUrlValueObject} from "../../../data/value-object/content/ContentDetailUrlValueObject";
import {ContentDetailUrlSearchOption} from "../../../data/search-option/content/ContentDetailUrlSearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import {ContentDetailUrlIO} from "../../../io/ContentIO";
import {ContentDetailUrlDescription} from "../../../data/description/content/ContentDetailUrlDescription";
import {ContentDetailUrlDescriptor} from "../../../data/descriptor/content/ContentDetailUrlDescriptor";
import ListOption from "../../ListOption";
import {
    ContentDetailUrlSearchOptionDescription
} from "../../../data/description/content/ContentDetailUrlSearchOptionDescription";
import {
    applyContentDetailUrlSearchOption,
    ContentDetailUrlSearchOptionField
} from "../../search-option-field/content/ContentDetailUrlSearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<ContentDetailUrlValueObject[]>([])
    const option = useStatePair<ContentDetailUrlSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={ContentDetailUrlIO}
                items={items}
                option={option.value}
                index={index}
                description={ContentDetailUrlDescription}
                descriptor={ContentDetailUrlDescriptor}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/contents/detailUrls/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={ContentDetailUrlSearchOptionDescription}
                fields={ContentDetailUrlSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyContentDetailUrlSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={ContentDetailUrlDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}